import BOARDS from '@/data/mock/boards'
import THREADS from '@/data/mock/threads'

export function getTopBoards(limit = 5) {
  return BOARDS.slice(0, limit)
}

export function getAllBoards() {
  return BOARDS
}

export function getTopApps() {
  return []
}

export function getAllApps() {
  return []
}

export function getThreads() {
  return THREADS
}
